import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom


function SelectRoleComponent() {
	const navigate = useNavigate();
    useEffect(() => {
        // Check if user is already logged in
        const token = localStorage.getItem('token');
        const userDetails = localStorage.getItem('userDetail');
        
        if (token && token !== 'null' && token !== 'undefined' && userDetails) {
          try {
            const parsedUserDetails = JSON.parse(userDetails);
            if (parsedUserDetails?.role === '1') {
              navigate('/user/dashboard');  // Navigate to user dashboard
            } else if (parsedUserDetails?.role === '2') {
             navigate('/user/dashboard'); 
            }
          } catch (error) {
            console.error('Error parsing user details:', error);
          }
        }
      }, [navigate]);  // Dependency on navigate to trigger on mount
 const handleRoleSelection = (role) => {
        
        navigate('/register', { state: { role } }); // Passing "role" as state
    };
    return (
        <div className='sign-up-main'>

    
        <div className='sign-left'>
        <div className='logo' onClick={() => navigate('/')}>
         <img src={window.getPublicUrl('/assets/images/main-logo.svg')}/>
        </div>    
       <h2>Welcome! Please Select Your Role</h2>
       <h4>Please select if you are joining as a 'User' or a 'Notary' to continue with the registration or login process.</h4>
<button className='btn-sign' onClick={() => handleRoleSelection('user')}>Continue as User</button>    
<button className='btn-sign btn2' onClick={() => handleRoleSelection('notary')}>Continue as Noatry</button>  
  
</div>
<div className='sign-right'>
<img src={window.getPublicUrl('/assets/images/login-bg.png')}/>
</div>
 
</div>
);
}
export default SelectRoleComponent;
